import type { NotificationEventType } from "@lumika/shared";

export type NotificationPresentation =
  | "action_required"
  | "information"
  | "system_health";

export const NOTIFICATION_PRESENTATION_COPY: Record<
  NotificationPresentation,
  { label: string; description: string }
> = {
  action_required: {
    label: "Action required",
    description:
      "Alerts that need a person to act. This feed is separate from the Inbox Needs you work queue.",
  },
  information: {
    label: "Information",
    description: "Updates that keep you informed but do not usually interrupt your work.",
  },
  system_health: {
    label: "System health",
    description: "Connection and integration status for administrators.",
  },
};

/**
 * UI grouping derived only from notification catalog metadata returned by
 * the backend. Channel-category events are system health; the remaining
 * escalation-severity events require action; normal events are information.
 */
export function notificationPresentation(
  event: Pick<NotificationEventType, "category" | "severity">,
): NotificationPresentation {
  if (event.category === "channel") return "system_health";
  if (event.severity === "escalation") return "action_required";
  return "information";
}

/** Normalize legacy catalog copy while preserving the technical `ai.*` key. */
export function assistantNotificationCopy(value: string): string {
  return value.replace(/\bAI\b/gu, "Assistant");
}
